"use strict"; // https://dom.spec.whatwg.org/#interface-nonelementparentnode
// getElementById is implemented separately inside Document and DocumentFragment.

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NonElementParentNodeImpl = function NonElementParentNodeImpl() {
  _classCallCheck(this, NonElementParentNodeImpl);
};

module.exports = {
  implementation: NonElementParentNodeImpl
};